// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsApplicationsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AcceptApplicationInvitationWebApiRequestDto,
  AcceptApplicationInvitationWebApiResponseDto,
  GetRentalApplicationWebApiResponseDto,
  ShareRentalApplicationWithLandlordWebApiRequestDto,
  StartApplicationWebApiRequestDto,
  StartApplicationWebApiResponseDto,
  SubmitApplicationWebApiRequestDto,
  WithdrawApplicationWebApiRequestDto,
  WithdrawSharedApplicationWebApiRequestDto,
} from '../..';

interface GetRentalApplicationParams {
  id: string;
}

export const CappsApplicationsWebApiHandler_acceptApplicationInvitation_Path =
  '/api/web/renter/v1/applications/acceptApplicationInvitation';

export const CappsApplicationsWebApiHandler_acceptApplicationInvitation = (
  postData: AcceptApplicationInvitationWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    AcceptApplicationInvitationWebApiRequestDto,
    AcceptApplicationInvitationWebApiResponseDto
  >(
    {
      endpoint: CappsApplicationsWebApiHandler_acceptApplicationInvitation_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsApplicationsWebApiHandler_getRentalApplication_Path =
  '/api/web/renter/v1/applications/getRentalApplication';

export const CappsApplicationsWebApiHandler_getRentalApplication = (
  getParams: GetRentalApplicationParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetRentalApplicationParams, never, GetRentalApplicationWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsApplicationsWebApiHandler_getRentalApplication_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsApplicationsWebApiHandler_shareRentalApplicationWithLandlord_Path =
  '/api/web/renter/v1/applications/shareRentalApplicationWithLandlord';

export const CappsApplicationsWebApiHandler_shareRentalApplicationWithLandlord = (
  postData: ShareRentalApplicationWithLandlordWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ShareRentalApplicationWithLandlordWebApiRequestDto, void>(
    {
      endpoint: CappsApplicationsWebApiHandler_shareRentalApplicationWithLandlord_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsApplicationsWebApiHandler_startApplication_Path = '/api/web/renter/v1/applications/startApplication';

export const CappsApplicationsWebApiHandler_startApplication = (
  postData: StartApplicationWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, StartApplicationWebApiRequestDto, StartApplicationWebApiResponseDto>(
    {
      endpoint: CappsApplicationsWebApiHandler_startApplication_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsApplicationsWebApiHandler_submitApplication_Path =
  '/api/web/renter/v1/applications/submitApplication';

export const CappsApplicationsWebApiHandler_submitApplication = (
  postData: SubmitApplicationWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SubmitApplicationWebApiRequestDto, void>(
    {
      endpoint: CappsApplicationsWebApiHandler_submitApplication_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsApplicationsWebApiHandler_withdrawApplication_Path =
  '/api/web/renter/v1/applications/withdrawApplication';

export const CappsApplicationsWebApiHandler_withdrawApplication = (
  postData: WithdrawApplicationWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, WithdrawApplicationWebApiRequestDto, void>(
    {
      endpoint: CappsApplicationsWebApiHandler_withdrawApplication_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsApplicationsWebApiHandler_withdrawSharedApplication_Path =
  '/api/web/renter/v1/applications/withdrawSharedApplication';

export const CappsApplicationsWebApiHandler_withdrawSharedApplication = (
  postData: WithdrawSharedApplicationWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, WithdrawSharedApplicationWebApiRequestDto, void>(
    {
      endpoint: CappsApplicationsWebApiHandler_withdrawSharedApplication_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};
